import { Routes, Route } from "react-router-dom";
import Story from "works/irene/pages/Story";

export default function IreneRoutes() {
  return (
    <Routes>
      <Route path="/story" element={<Story />} />
    </Routes>
  );
}
